var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.572,
    height: 39.221,
    viewBox: "0 0 21.572 39.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "attach_file_FILL0_wght400_GRAD0_opsz48",
    d: "M22.786,43.221a10.56,10.56,0,0,1-7.624-3.064A10.071,10.071,0,0,1,12,32.631V11.55a7.238,7.238,0,0,1,2.231-5.344A7.36,7.36,0,0,1,19.6,4a7.336,7.336,0,0,1,5.393,2.206A7.336,7.336,0,0,1,27.2,11.6V30.916a4.346,4.346,0,0,1-1.275,3.162,4.224,4.224,0,0,1-3.138,1.3,4.081,4.081,0,0,1-3.138-1.4,4.746,4.746,0,0,1-1.275-3.309V11.452h1.961V30.817a2.594,2.594,0,0,0,.711,1.838,2.292,2.292,0,0,0,1.74.76,2.327,2.327,0,0,0,1.74-.735,2.449,2.449,0,0,0,.711-1.765V11.55a5.358,5.358,0,0,0-1.642-3.971,5.481,5.481,0,0,0-4-1.618,5.481,5.481,0,0,0-4,1.618,5.358,5.358,0,0,0-1.642,3.971V32.73a8.042,8.042,0,0,0,2.6,6.055,8.708,8.708,0,0,0,6.226,2.476,8.639,8.639,0,0,0,6.251-2.5,8.213,8.213,0,0,0,2.574-6.128V11.452h1.961v21.13a10.15,10.15,0,0,1-3.162,7.55A10.516,10.516,0,0,1,22.786,43.221Z",
    transform: "translate(-12 -4)",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachement);
export default __webpack_public_path__ + "static/media/attachement.89859071c94473d3ee29dc45e768fb45.svg";
export { ForwardRef as ReactComponent };